// `image.advanced`: live's image Advanced mode (G8): ad creatives for one product.
// The Advanced form (#234) sends its own body: a draft has no product or ad copies, and
// no source makes one, so it is its own pair.
import { ImageAdvancedQuote, ImageAdvancedRequest } from "../../../api/generated/zod";
import type { JobTypeModule } from "./contract";

export const jobType: JobTypeModule<"image.advanced"> = {
  type: "image.advanced",
  label: "Advanced",
  detailTitle: "Advanced Generation",
  source: "form",
  pair: "image.advanced",
  fields: () => ({}),
  request: ImageAdvancedRequest,
  quote: ImageAdvancedQuote,
};
